import { Injectable } from '@angular/core';
import { HTS_CHAT_AUTO_STARTED_STORAGE_KEY } from '../const/hts-assistant.const';

/**
 * Keeps (per browser tab) the ids of the conversations this client started from the line's stored description: only
 * their first message is the description echo the thread hides — a description the user typed stays visible.
 */
@Injectable({ providedIn: 'root' })
export class HtsChatSessionService {
  public getAutoStartedIds(): number[] {
    try {
      const raw: string = sessionStorage.getItem(HTS_CHAT_AUTO_STARTED_STORAGE_KEY);
      const ids: unknown = raw ? JSON.parse(raw) : [];
      return Array.isArray(ids) ? ids.filter((id: unknown) => typeof id === 'number') : [];
    } catch (e) {
      return [];
    }
  }

  public markAutoStarted(ids: number[]): void {
    const known: number[] = this.getAutoStartedIds();
    const merged: number[] = [...known, ...ids.filter((id: number) => !known.includes(id))];
    try {
      sessionStorage.setItem(HTS_CHAT_AUTO_STARTED_STORAGE_KEY, JSON.stringify(merged));
    } catch (e) {
      // storage unavailable: the echo will show up as a bubble after a reopen — nothing is lost
    }
  }
}
